module.exports = __webpack_public_path__ + "static/media/Cubrimos-Cada-Rincon.de48f00c.svg";